import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, useInRouterContext } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

function SafeApp() {
  let inRouter = false;
  try {
    inRouter = useInRouterContext();
  } catch (e) {
    inRouter = false;
  }

  if (inRouter) {
    return <App />;
  }
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

createRoot(document.getElementById('root')).render(
  <SafeApp />
)
